import { render, staticRenderFns } from "./HighEndNotice.vue?vue&type=template&id=b241fa14&scoped=true&"
import script from "./HighEndNotice.vue?vue&type=script&lang=js&"
export * from "./HighEndNotice.vue?vue&type=script&lang=js&"
import style0 from "./HighEndNotice.vue?vue&type=style&index=0&id=b241fa14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b241fa14",
  null
  
)

export default component.exports